import antdData from 'antd/lib/locale-provider/es_ES'
import localeData from 'react-intl/locale-data/es'
import countries from './countries/es.json'
import languages from './languages/es.json'
import platform from './platform/es.json'
import urls from './urls/es.json'
import texts from './texts/es.json'
import faq from './faq/es.json'

export default {
  locale: 'es',
  antdData,
  localeData,
  messages: { ...texts, ...countries, ...languages, ...platform, ...urls, ...faq },
}
